import { GA4EventName, GA4FeatureCategory, trackAnalyticsEvent } from '@jsmdg/tracking';

function trackProductItemClicked(label: string): void {
    setTimeout(() => {
        trackAnalyticsEvent({
            category: 'ProductDetail',
            action: 'ButtonClick',
            label,
            eventData: {
                eventName: GA4EventName.SelectProductVariant,
                feature_category: GA4FeatureCategory.ProductdetailBuybox,
                selected_value: label,
            },
        });
    }, 0);
}

export { trackProductItemClicked };
